import { CookieMonster } from 'root/utils/cookies/cookieMonster';
export default class DefaultController {
    /**
     * Created by samuel.tissot on 2017-05-08.
     */
    constructor(name) {
        this.name = name;
        this.twig = null;
        this.data = null;
        this.dependencies = [];
        this.selector = '';
        this.cm = new CookieMonster();
    }

    setTwig(twigContent) {
        if (twigContent.trim()) {
            this.twig = twigContent;
        } else {
            throw new AjaxContentException('empty twig file');
        }
    }

    setData(data) {
        'use strict';
        this.data = data;
    }

    setSelector(str) {
        return (this.selector = str);
    }

    load() {
        'use strict';
        console.log('--- DefaultController ---');
    }

    gethtmlToInsert() {
        const d = document.createElement('div');
        d.classList.add(this.name.replace(/_/g, '-'));
        d.innerHTML = this.twig;
        return d;
    }

    insertAsFirstChild(targetString, elementToInsert) {
        const target = document.querySelector(targetString);
        target.insertBefore(elementToInsert, target.firstChild);
    }

    insertAsLastChild(targetString, elementToInsert) {
        const target = document.querySelector(targetString);
        if (target) {
            target.append(elementToInsert);
            const keyboardFocusableElements =
                'a[href], button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])';
            target.children[target.children.length - 1]
                .querySelector(keyboardFocusableElements)
                ?.focus();
        }
    }

    insertBeforeTarget(targetString, elementToInsert) {
        const target = document.querySelector(targetString);
        target.parent.insertBefore(elementToInsert, target);
    }

    insertAfterTarget(targetString, elementToInsert) {
        const target = document.querySelector(targetString);
        target.parent.insertAfter(elementToInsert, target);
    }
}
